/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AppointmentHistory from './appointment-history';
import AppointmentHistoryDetail from './appointment-history-detail';
import AppointmentHistoryUpdate from './appointment-history-update';
import AppointmentHistoryDeleteDialog from './appointment-history-delete-dialog';

const AppointmentHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AppointmentHistory />} />
    <Route path="new" element={<AppointmentHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<AppointmentHistoryDetail />} />
      <Route path="edit" element={<AppointmentHistoryUpdate />} />
      <Route path="delete" element={<AppointmentHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AppointmentHistoryRoutes;
